import {EventBusConsumer} from "Core/Common/EventBus/EventBusConsumer";

import {BaseProductGroup} from "./BaseProductGroup";
import {RootGroup} from "./RootGroup";

import {ImageTableTypes} from "../../../Components/ProductImageViewer/Enums/ImageTableTypes";
import { ImagePreloader } from "../../../../../../Common/Image";
import { Notifier } from "Core/Common/Notifier";

export abstract class BaseProduct extends EventBusConsumer {
    protected container: HTMLElement;
    public Image: string;

    public DrawingImage: KnockoutObservable<string>;

    protected constructor(public Id: number,
                          public KSeq: number,
                          public Name: string,
                          public NameTranslated: string,
                          image: string,
                          public EnableCustomImage: boolean,
                          public EnableDrawing: boolean,
                          public CustomImageData: string,
                          public CustomImageThumbnail: string,
                          public CustomImageKSeq: number,
                          public Drawing: string,
                          public Description: string,
                          protected basePrice: number,
                          protected parentGroup: BaseProductGroup,
                          public IsNew: boolean) {
        super();

        this.DrawingImage = ko.observable<string>(this.AddBase64Image(this.CustomImageThumbnail));
        this.Image = image ? `api/FilesApi/GetImage/${image}` : null;
        ImagePreloader.Preload(this.Image);
    }
    SetDrawingImage(image: string) {
        if(!this.EnableCustomImage){
            Notifier.Warning("Custom image is not allowed.");
            return;
        }

        if (image) {
            this.DrawingImage(this.AddBase64Image(image));
            this.CustomImageData = image;
            this.CustomImageThumbnail = image;
        } else {
            this.DrawingImage(null);
        }
    }

    AddBase64Image(base64: string) {
        if (!base64 && base64 != '') {
            return null;
        }
        const supportedMimeTypes = [
          'image/png',
          'image/jpeg',
          'image/jpg',
          'image/webp',
          'image/gif'
        ];
      
        const prefixMatch = supportedMimeTypes.find(type => base64.startsWith(`data:${type};base64,`));
        const isFullDataUrl = Boolean(prefixMatch);
        
        const base64Prefix = isFullDataUrl ? '' : 'data:image/png;base64,';
        return base64Prefix + base64;
    }

    get Container() {
        return this.container;
    }

    get BasePrice() {
        return this.basePrice;
    }

    get ParentGroup() {
        return this.parentGroup;
    }

	get ImageTableType() {
		return ImageTableTypes.Product;
	}

    abstract RootGroupIs(rootGroup: RootGroup);

    AfterRender(el: HTMLElement) {
        this.container = el[0];
    }
}